import * as React from 'react';
import { useIntl } from 'react-intl';
import { BannerNotification } from '@siteground/styleguide';

export const OfflineBanner = () => {
  const [isHidden, setIsHidden] = React.useState(navigator.onLine);
  const intl = useIntl();

  const handleOffline = () => setIsHidden(() => false);
  const handleOnline = () => setIsHidden(() => true);

  React.useEffect(() => {
    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  if (isHidden) {
    return null;
  }

  return (
    <BannerNotification
      density="small"
      title={intl.formatMessage({ id: 'translate.generic.no.internet.connection' })}
      type="error"
    />
  );
};
